import _ from 'lodash';
import update from 'immutability-helper';
import classNames from 'classnames';
import objectAssign from 'object-assign';
import Fuse from 'fuse.js';
import { DropTarget } from 'react-dnd';
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { /* Link,*/ withRouter } from 'react-router';
import FontAwesome from 'react-fontawesome';
import { SelectableGroup, createSelectable } from 'react-selectable';
import * as actions from '../../../actions/regActions';
import TextInput from '../../../components/common/TextInput';
import SelectInput from '../../../components/common/SelectInput';
import TeamMember from './TeamMember';
// import Estimates from './Estimates';
import NumberFormat from 'react-number-format';
import Button from '../../../components/common/Button';
import SortBy from '../../../components/common/SortBy';
import * as SortByUtils from '../../../components/common/sortByUtils';
// import toastr from 'toastr';

function checkDate(before, after) {
  if (before && after) {
    return Date.parse(before) >= Date.parse(after);
  } else {
    return true;
  }
}

const memberTarget = {
  canDrop(props, monitor) {
    // You can disallow drop based on props or item
    let category = _.find(props.team.team_categories,
      {id: Number(props.details.team_category)});
    let members = props.details.members;
    let membersSize = _(members).filter({'_destroy': false}).size();
    let item = monitor.getItem();
    let size = _.size(item.items);
    if (category.max_members && size > 1 &&
        _.gt((membersSize + size), category.max_members)) {
      return false;
    }
    return _.every(item.items, (item) => {
      let alreadyPresent = _.find(props.details.members, {member_reg: item.id, _destroy: false});
      let bellowMaxMembers = !!alreadyPresent || !category.max_members || membersSize < category.max_members;
      let bellowMaxAge = checkDate(item.member_details.birth_date, category.max_birthdate);
      let aboveMinAge = checkDate(category.min_birthdate, item.member_details.birth_date);
      return aboveMinAge && bellowMaxAge && bellowMaxMembers;
    });
  },

  // hover(props, monitor, component) {
  //   // This is fired very often and lets you perform side effects
  //   // in response to the hover. You can't handle enter and leave
  //   // here—if you need them, put monitor.isOver() into collect() so you
  //   // can just use componentWillReceiveProps() to handle enter/leave.
  //
  //   // You can access the coordinates if you need them
  //   const clientOffset = monitor.getClientOffset();
  //   const componentRect = findDOMNode(component).getBoundingClientRect();
  //
  //   // You can check whether we're over a nested drop target
  //   const isJustOverThisOne = monitor.isOver({ shallow: true });
  //
  //   // You will receive hover() even for items for which canDrop() is false
  //   const canDrop = monitor.canDrop();
  // },

  drop(props, monitor, component) {
  //   if (monitor.didDrop()) {
  //     // If you want, you can check whether some nested
  //     // target already handled drop
  //     return;
  //   }
    // Obtain the dragged item
    const item = monitor.getItem();
    // console.log(item);
    component.addMemberRegToTeam(item);
  //
  //   // You can do something with it
  //   ChessActions.movePiece(item.fromPosition, props.position);
  //
    // You can also do nothing and return a drop result,
    // which will be available as monitor.getDropResult()
    // in the drag source's endDrag() method

    return props;
  }
};

function collect(connect, monitor) {
  return {
    // Call this function inside render()
    // to let React DnD handle the drag events:
    connectDropTarget: connect.dropTarget(),
    // You can ask the monitor about the current drag state:
    isOver: monitor.isOver(),
    isOverCurrent: monitor.isOver({ shallow: true }),
    canDrop: monitor.canDrop(),
    itemType: monitor.getItemType()
  };
}

const SelectableTeamMember = createSelectable(TeamMember);

class TeamForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
    this.updateField = this.updateField.bind(this);
    this.changeCategory = this.changeCategory.bind(this);
    this.dynamicTeamField = this.dynamicTeamField.bind(this);
    this.renderTeamMembers = this.renderTeamMembers.bind(this);
    this.staticTeam = this.staticTeam.bind(this);
    this.hoverColor = this.hoverColor.bind(this);
    this.newID = this.newID.bind(this);
    this.addMemberRegToTeam = this.addMemberRegToTeam.bind(this);
    this.removeMemberRegFromTeam = this.removeMemberRegFromTeam.bind(this);
    this.categoryCount = this.categoryCount.bind(this);
    this.requiredMemberCatErrorMessage = this.requiredMemberCatErrorMessage.bind(this);
    this.checkRequiredMemberCategories = this.checkRequiredMemberCategories.bind(this);
    this.checkCategoryRequirements = this.checkCategoryRequirements.bind(this);
    this.updateTeamMember = this.updateTeamMember.bind(this);
    this.clearAllMembers = this.clearAllMembers.bind(this);
    this.checkMaxMembers = this.checkMaxMembers.bind(this);
    this.checkMinMembers = this.checkMinMembers.bind(this);
    this.renderErrorMessages = this.renderErrorMessages.bind(this);
    this.getMemberDiff = this.getMemberDiff.bind(this);
    this.renderMemberInterface = this.renderMemberInterface.bind(this);
    this.addToSelected = this.addToSelected.bind(this);
    this.handleDragSelection = this.handleDragSelection.bind(this);
    this.selectOrClear = this.selectOrClear.bind(this);
    this.clearSelected = this.clearSelected.bind(this);

    this.filterUpdate = this.filterUpdate.bind(this);
    this.sortUpdate = this.sortUpdate.bind(this);

    this.toggle = this.toggle.bind(this);
    let category = _.find(this.props.team.team_categories,
      {id: Number(this.props.details.team_category)});
    this.state = {
      selectedMembers: [],
      showFilter: false,
      filter: "",
      showSortOptions: false,
      sortOptions: [
        {value: 'member_reg_details.member_details.first_name', label: 'Fornavn'},
        {value: 'member_reg_details.member_details.last_name', label: 'Etternavn'},
        {value: 'member_reg_details.member_details.birth_date', label: 'Fødselsdag'}
      ],
      sortedBy: '',
      sortedByDir: '',
      details: props.details,
      category: category,
      errors: props.errors,
      showDetails: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if(!_.isEqual(nextProps.details, this.props.details)) {
      let category = _.find(nextProps.team.team_categories,
        {id: Number(nextProps.details.team_category)});
      this.setState({
        details: nextProps.details,
        category: category,
      });
    }
    if(!_.isEqual(nextProps.errors, this.props.errors)) {
      this.setState({
        errors: nextProps.errors,
      });
    }
  }

  filterUpdate(e) {
    let filter = e.target.value;
    this.setState({
      filter: filter
    });
  }

  sortUpdate(value) {
    let newState = SortByUtils.updateSortedBy(value,
      this.state.sortedBy,
      this.state.sortedByDir);
    this.setState(newState);
  }

  hoverColor() {
    if (this.props.isOver) {
      return this.props.canDrop;
    } else {
      return undefined;
    }
  }

  toggle(part) {
    this.setState({
      [part]: !this.state[part]
    });
  }

  newID() {
    return '_' + Math.random().toString(36).substr(2, 20);
  }

  addMemberRegToTeam(item) {
    let members = this.props.details.members;
    let details = this.props.details;
    item.items.forEach((memberReg) => {
      let index = _.findIndex(members, {member_reg: memberReg.id});
      if (index != -1) {
        details = update(details, {members: {[index]:
          {'_destroy': {$set: false}}
        }});
      } else {
        let teamMember = {
          member_reg: memberReg.id,
          _destroy: false,
          member_reg_details: memberReg,
          categories: [],
          identifier: this.newID()
        };
        details = update(details, {members: {$push: [teamMember]}});
      }
    });
    this.props.updateTeam(details);
  }

  removeMemberRegFromTeam(memberReg) {
    let details = this.props.details;
    if (Array.isArray(memberReg)) {
      memberReg.forEach((member) => {
        let index = _.findIndex(this.props.details.members, {member_reg: member.id});
        details = update(details, {members: {[index]:
          {'_destroy': {$set: true}}
        }});
      })
    } else {
      let index = _.findIndex(this.props.details.members, {member_reg: memberReg.id});
      details = update(details, {members: {[index]:
        {'_destroy': {$set: true}}
      }});
    }
    this.props.updateTeam(details);
  }

  clearAllMembers() {
    if (!confirm('Ønsker du å fjerne alle deltagerne')) {
      return false;
    }
    let members = _.map(this.state.details.members, (member) => {
      return update(member, {'_destroy': {$set: true}});
    });
    let details = update(this.state.details, {members: {$set: members}});
    this.props.updateTeam(details);
  }

  updateField(event) {
    let details = objectAssign({}, this.state.details);
    details[event.target.name] = event.target.value;
    this.props.updateTeam(details);
  }

  changeCategory(event) {
    let details = objectAssign({}, this.props.details);
    details.team_category = event.target.value;
    let members = details.members.map((member) =>{
      return update(member, {categories: {$set: []}});
    });
    details.members = members;
    this.props.updateTeam(details);
  }

  updateTeamMember(member) {
    let index = _.findIndex(this.state.details.members, {identifier: member.identifier});
    let details = update(this.state.details, {members: {$splice: [[index, 1, member]]}});
    this.props.updateTeam(details);
  }

  categoryCount() {
    return _(this.props.details.members)
      .filter({'_destroy': false})
      .flatMap('categories')
      .countBy((categoryId) => {
      return categoryId;
    }).value();
  }

  checkRequiredMemberCategories() {
    let checkRequired = _(this.props.details.members).filter({'_destroy': false}).some((member) => {
      return _.isEmpty(member.categories);
    });
    return (checkRequired && this.state.category.require_member_category);
  }

  requiredMemberCatErrorMessage() {
    if (!this.checkRequiredMemberCategories()) {
      return null;
    }
    return (
      <div className="alert alert-danger">
        {'OBS! Alle deltagere må ha minst en kategori'}
      </div>
    );
  }

  checkCategoryRequirements() {
    let anyCheckErrors = _(this.state.details.members).filter({'_destroy': false})
      .find((member) => {
        let birthday = member.member_reg_details.member_details.birth_date;
        let minAge = this.state.category.min_birthdate;
        let maxAge = this.state.category.max_birthdate;
        let bellowMaxAge = checkDate(birthday, maxAge);
        let aboveMinAge = checkDate(minAge, birthday);
        return !(bellowMaxAge && aboveMinAge);
      });

    return !!anyCheckErrors;
  }

  getMemberDiff() {
    let deleted = [];
    let added = [];
    let changed = [];
    if (this.props.teamDiff.isDifferent) {
      _(this.props.teamDiff.members).forEach((item, key) => {
        if (item[1] === 0 && item[2] === 0) {
          deleted.push(item[0]);
        } else if(typeof item != 'string' &&
            item[1] === undefined &&
            item[2] === undefined &&
            item[0] !== undefined) {
          added.push(item[0]);
        } else if(typeof item != 'string' && this.state.details.members && this.state.details.members[key]) {
          let member = this.state.details.members[key];
          let memberDiff = {
            id: member.id,
            member_reg: member.member_reg,
            ...item
          };
          changed.push(memberDiff);
        }
      });
    }
    return {
      deleted,
      added,
      changed,
      allChanged: [...deleted, ...added, ...changed]
    };
  }

  renderMemberInterface() {
    return (
      <div>
        <div className={classNames("", {
            'hidden': !this.state.showFilter
          })}>
          <div className="input-group">
            <span className="input-group-addon" id="basic-addon3">
              <FontAwesome
                name="search" />
            </span>
            <input
              type="search"
              className="form-control"
              onChange={this.filterUpdate}
              value={this.state.filter}
              />
          </div>
          <hr/>
        </div>
        <div className={classNames("", {
            'hidden': !this.state.showSortOptions
          })}>
          <SortBy
            sortedBy={this.state.sortedBy}
            sortedByDir={this.state.sortedByDir}
            sortOptions={this.state.sortOptions}
            updateCB={this.sortUpdate}
             />
          <hr/>
        </div>
      </div>
    );
  }


  // {this.state.sortOptions}

    addToSelected(member) {
      let index = _.findIndex(this.state.selectedMembers, {id: member.id});
      let selectedMembers = this.state.selectedMembers;
      if (index == -1) {
        selectedMembers = update(selectedMembers, {$push: [member]});
      } else {
        selectedMembers = update(selectedMembers, {$splice: [[index, 1]]});
      }
      this.setState({
        selectedMembers: selectedMembers
      });
    }

    handleDragSelection (selected, ev) {
      if (ev.shiftKey) {
        let resultSelected = _.union(selected, this.state.selectedMembers)
        this.setState({ selectedMembers: resultSelected });
      } else {
        this.setState({ selectedMembers: selected });
      }
    }

    selectOrClear() {
      if (!_(this.state.selectedMembers).filter({'_destroy': false}).size()) {
        this.setState({
          selectedMembers: _(this.props.details.members).filter({'_destroy': false}).flatMap('member_reg_details').value(),
        });
      } else {
        this.clearSelected();
      }
    }

    clearSelected() {
      this.setState({
        selectedMembers: [],
      });
    }



  renderTeamMembers() {
    let filteredMember = _.filter(this.state.details.members,
      {'_destroy': false});
    let diff = {deleted: []};
    if (this.props.teamDiff && this.props.teamDiff.members) {
      diff = this.getMemberDiff();
    }
    if (_.isEmpty(filteredMember) && _.isEmpty(diff.deleted)) {
      return false;
    }
    if(this.state.sortedBy) {
      filteredMember = SortByUtils.sortBy(filteredMember, this.state.sortedBy, this.state.sortedByDir)
    }
    if(this.state.filter) {
      let search = new Fuse((filteredMember),{
        shouldSort: true,
        distance: 5,
        keys: ["member_reg_details.member_details.first_name",
        "member_reg_details.member_details.last_name"]
        });
      filteredMember = search.search(this.state.filter);
    }
    return (
      <div>
        {this.requiredMemberCatErrorMessage()}
        {this.renderMemberInterface()}
        <SelectableGroup onSelection={this.handleDragSelection} >
          {filteredMember.map((member) => {
            let diffStatus = {};
            let memberDiff = _.find(diff.allChanged, {id: member.id});
            diffStatus['added'] = !_.isEmpty(_.filter(diff.added, {id: member.id}));
            diffStatus['deleted'] = !_.isEmpty(_.filter(diff.deleted, {id: member.id}));
            diffStatus['changed'] = !_.isEmpty(_.filter(diff.changed, {id: member.id}));
            let selected = (
              _.findIndex(this.state.selectedMembers, {id: member.member_reg_details.id}) != -1
            );
            return (<SelectableTeamMember key={member.identifier}
              allMemberCategories={this.props.allMemberCategories}
              disabled={this.props.disabled}
              team={this.state.details}
              memberDiff={memberDiff}
              diffStatus={diffStatus}
              clearSelected={this.clearSelected}
              selected={selected}
              selectableKey={member.member_reg_details}
              selectedMembers={this.state.selectedMembers}
              addToSelected={this.addToSelected}
              teamCategory={this.state.category}
              usedMemberCategories={this.categoryCount()}
              memberCategories={this.state.category.member_categories}
              updateTeamMember={this.updateTeamMember}
              removeMemberRegFromTeam={this.removeMemberRegFromTeam}
              list={this.state.details.members}
              member={member} />);
          })}
          </SelectableGroup>
          {!_.isEmpty(diff.deleted) && <div className="page-header">
            <h5 className="text-warning">
              <FontAwesome name="warning" />
              &emsp;
              {'Slettede deltagere (venter på endingsgodkjenning)'}
            </h5>
          </div>}
          {diff.deleted.map((member) => {
            let diffStatus = {};
            let memberDiff = _.find(diff.allChanged, {id: member.id});
            diffStatus['added'] = !_.isEmpty(_.filter(diff.added, {id: member.id}));
            diffStatus['deleted'] = !_.isEmpty(_.filter(diff.deleted, {id: member.id}));
            diffStatus['changed'] = !_.isEmpty(_.filter(diff.changed, {id: member.id}));
            let selected = (
              _.findIndex(this.state.selectedMembers, {id: member.member_reg_details.id}) != -1
            );
            return (
              <TeamMember
                key={member.identifier}
                allMemberCategories={this.props.allMemberCategories}
                disabled={true}
                team={this.state.details}
                memberDiff={memberDiff}
                diffStatus={diffStatus}
                teamCategory={this.state.category}
                usedMemberCategories={this.categoryCount()}
                clearSelected={this.clearSelected}
                selected={selected}
                selectedMembers={this.state.selectedMembers}
                addToSelected={this.addToSelected}
                memberCategories={this.state.category.member_categories}
                updateTeamMember={this.updateTeamMember}
                removeMemberRegFromTeam={this.removeMemberRegFromTeam}
                list={this.state.details.members}
                member={member} />
            );
          })}
      </div>
    );
  }

  staticTeam() {
    // let category = _.find(this.props.team.team_categories,
    //   {id: Number(this.state.details.team_category)});
    if (!this.state.showDetails) {
      return null;
    }
    return (
      <div className={classNames('panel-body static-team ', {'hidden': !this.state.showDetails})}>
        {/*<Estimates
          show={category.gather_estimates || !_.isEmpty(this.state.details.member_estimates)}
          team={this.props.details}
          category={category}
          estimates={this.state.details.member_estimates}
          />*/}
        {this.renderErrorMessages(this.checkMaxMembers(), this.checkMinMembers())}
        <div>
          <span className={classNames("btn btn-xs", {
              'btn-default': !this.state.showFilter,
              'btn-info': this.state.showFilter,
              'btn-warning': this.state.filter
            })}
            onClick={() => {this.toggle('showFilter')}}>
            <FontAwesome
              name="search" className="fa fa-fw" />
          </span>
          &nbsp;
          <span className={classNames("btn btn-xs", {
              'btn-default': !this.state.showSortOptions,
              'btn-info': this.state.showSortOptions,
              'btn-warning': this.state.sortedBy,
            })}
            onClick={() => {this.toggle('showSortOptions')}}>
            <FontAwesome
              name="sort-amount-asc" className="fa fa-fw" />
          </span>
          &nbsp;
          {!this.props.disabled && <a className="btn btn-xs btn-default"
            onClick={this.selectOrClear}>
            <FontAwesome
              name="check-square-o"
              />
          </a>}
        </div>
        <hr/>
        {this.renderTeamMembers()}
      </div>
    );
  }

  dynamicTeamField() {
    let teamCatOptions = objectAssign([], this.props.team.team_categories);
    teamCatOptions = _.map(teamCatOptions, (cat) => {
      return {value: cat.id, text: cat.name + ' ' + cat.price};
    });
    if (!this.state.showDetails) {
      return null;
    }
    let diffobject = this.props.teamDiff.isDifferent ? this.props.teamDiff : {};
    return (
      <div className={classNames('panel-body ', {'hidden': !this.state.showDetails})}>
        {this.renderErrorMessages(this.checkMaxMembers(), this.checkMinMembers())}
        <TextInput
          name="name"
          label="Navn"
          disabled={this.props.disabled}
          diffObject={diffobject}
          onChange={this.updateField}
          value={this.state.details.name}
          />
        <SelectInput
          label={this.props.team.name + ' (kategori)'}
          name={"team_category"}
          disabled={this.props.disabled}
          diffObject={diffobject}
          value={this.state.details.team_category}
          onChange={this.changeCategory}
          optionsName={'text'}
          optionsValue={'value'}
          options={teamCatOptions} />
        {!this.props.disabled &&<Button
          className="btn btn-danger btn-xs"
          onClick={(e) => {
            this.props.removeTeam(this.props.details, e);
          }}
          faName="trash"
          >
          {' Slett'}
        </Button>}
        {/*<Estimates
          show={category.gather_estimates || !_.isEmpty(this.state.details.member_estimates)}
          team={this.props.details}
          category={category}
          estimates={this.state.details.member_estimates}
          />*/}
        <div className="page-header">
          <h4>
            {diffobject.members && <span>
              <FontAwesome name="warning" className="text-warning" />
              &emsp;
            </span>}
            {'Deltagere'}
            <span className="pull-right">
              <span className={classNames("btn btn-xs", {
                  'btn-info': this.state.showFilter,
                  'btn-default': !this.state.showFilter,
                  'btn-warning': this.state.filter,
                })}
                onClick={() => {this.toggle('showFilter')}}>
                <FontAwesome
                  name="search" className="fa fa-fw" />
              </span>
              &nbsp;
              <span className={classNames("btn btn-xs", {
                  'btn-default': !this.state.showSortOptions,
                  'btn-info': this.state.showSortOptions,
                  'btn-warning': this.state.sortedBy,
                })}
                onClick={() => {this.toggle('showSortOptions')}}>
                <FontAwesome
                  name="sort-amount-asc" className="fa fa-fw" />
              </span>
              &nbsp;
              {!this.props.disabled && <a className="btn btn-xs btn-default"
                onClick={this.selectOrClear}>
                <FontAwesome
                  name="check-square-o"
                  />
              </a>}
            </span>
          </h4>
        </div>
        {this.renderTeamMembers() || <div className="alert alert-info">
          Ingen deltagere.
        </div>}
      </div>
    );
  }

  checkMaxMembers() {
    let category = _.find(this.props.team.team_categories,
      {id: Number(this.state.details.team_category)});
    let membersSize = _(this.state.details.members).filter({_destroy: false}).size();
    if (category.max_members && membersSize > category.max_members) {
      return "For mange deltagere";
    }
  }

  checkMinMembers() {
    let category = _.find(this.props.team.team_categories,
      {id: Number(this.state.details.team_category)});
    let membersSize = _(this.state.details.members).filter({_destroy: false}).size();
    if (category.min_members && membersSize < category.min_members) {
      return "For få deltagere";
    }
  }

  renderErrorMessages(...errors) {
    if (_.some(errors)) {
      return (
        <div className="alert alert-danger">
          {errors.map((error, index) => {
            return <span key={index}>{error}</span>;
          })}
        </div>
      );
    }
  }

  render() {
    let headingArray = [this.state.category.name];
    if (this.state.details.name) {
      headingArray.push(this.state.details.name);
    }
    let heading = headingArray.join(" - ");
    let totalMembers = _.countBy(this.state.details.members,
      (member) => {return member._destroy == false;}).true;

    let errors = this.renderErrorMessages(this.checkMaxMembers(), this.checkMinMembers());

    return this.props.connectDropTarget(
      <div className={classNames('drop-target panel', {
          'panel-default': this.hoverColor() == undefined,
          'panel-danger': this.checkRequiredMemberCategories() ||
            this.checkCategoryRequirements() || !!errors,
          'panel-danger striped-error-bg': this.hoverColor() == false,
          'panel-success': this.hoverColor() == true,
          'panel-disabled': this.props.disabled,
        })}>
        <div className="panel-heading" onClick={() => {
            this.toggle('showDetails');
          }}>
          <h5>
            {this.props.diffStatus['deleted'] && <span>
              <FontAwesome name="minus-square" className="text-danger" />
              &emsp;
            </span>}
            {this.props.diffStatus['changed'] && <span>
              <FontAwesome name="warning" className="text-warning" />
              &emsp;
            </span>}
            {this.props.diffStatus['added'] && <span>
              <FontAwesome name="plus-square" className="text-success" />
              &emsp;
            </span>}
            {heading}
            {' '}
            {!!totalMembers &&
              <span className="label label-default pull-right">
                {totalMembers + ' deltagere'}
              </span>}
          </h5>
          <p>
            {!this.props.team.static_categories && ('Pris ' + this.props.team.name.toLowerCase() + ': ')}
            {!this.props.team.static_categories && this.state.category.price == '0.00' && '0 kr.'}
            <NumberFormat value={Number(this.state.category.price)}
              displayType={'text'}
              thousandSeparator={'.'}
              decimalSeparator={','} suffix={' kr.'} />
            {this.state.category.price_per_member != '0.00' && ('Pris per deltager: ')}
            <NumberFormat value={Number(this.state.category.price_per_member)}
              displayType={'text'}
              thousandSeparator={'.'}
              decimalSeparator={','} suffix={' kr.'} />
          </p>
        </div>
        {!this.props.team.static_categories && this.dynamicTeamField()}
        {this.props.team.static_categories && this.staticTeam()}
      </div>
    );
  }
}

TeamForm.propTypes = {
  actions: PropTypes.object.isRequired,
  details: PropTypes.object.isRequired,
  connectDropTarget: PropTypes.func,
  isOver: PropTypes.bool,
  canDrop: PropTypes.bool,
  updateTeam: PropTypes.func.isRequired,
  removeTeam: PropTypes.func.isRequired,
  team: PropTypes.object.isRequired,
  teamDiff: PropTypes.object,
  teamIndex: PropTypes.number.isRequired,
  errors: PropTypes.object,
  diffStatus: PropTypes.object,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  show: PropTypes.bool,
  allMemberCategories: PropTypes.array,
};

function mapStateToProps(state, ownProps) {
  return {
    loading: state.registration.loading,
    errors: state.registration.errors,
    eventDetails: state.events.eventDetails,
    clubDetails: state.clubs.clubDetails,
    eventId: ownProps.eventId,
    clubId: ownProps.clubId,
    detailsUpdated: state.registration.detailsUpdated,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default withRouter(
  compose(
    connect(mapStateToProps,mapDispatchToProps),
    DropTarget('MEMBER', memberTarget, collect)
  )(TeamForm));



/** WEBPACK FOOTER **
 ** ./src/containers/events/register/TeamForm.js
 **/